<template>
   <div class="layout">
    <!-- 上面导航 -->
     <div class="sidebat">
        <Sidebar ></Sidebar>
     </div>
     <!-- 中间内容 -->
      <div class="content" :class="{small: isCollapse}">
      <div class="warpper">
        <keep-alive include="home">
          <router-view />
        </keep-alive>
      </div>
    </div>
      <!-- 网页底部 -->
       <Footer></Footer>
   </div>
  </template>
  
  <script>
import Sidebar from "./sidebar/Index.vue"
import Footer from "./footer/Index.vue"


  export default {
    name: 'layoutIndex',  // 修改为多词的组件名称
    components: {
    Sidebar,
    Footer,
  },
  data() {
  return {
    isCollapse: false, // 根据需要设置初始值
  };
},
methods:{
  changeShow() {
    this.isCollapse = !this.isCollapse;
  }
}
  }
  </script>
  
  <style>


  .small{
    padding-left: 64px;
    
  }
  </style>